/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * RakeBack Wizard API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query'

import type {
  ReportablePokerSite,
  RoomList,
  RoomTag,
  UserRoomReportCreate,
  UserUnverifiedReport,
} from '../models'

import roomListListMutator from '../../client'
import roomReportSignupCreateMutator from '../../client'
import roomReportableSitesListMutator from '../../client'
import roomTagCreateMutator from '../../client'
import roomUnverifiedReportsListMutator from '../../client'

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> =
  (<T>() => T extends X ? 1 : 2) extends <T>() => T extends Y ? 1 : 2 ? A : B

type WritableKeys<T> = {
  [P in keyof T]-?: IfEquals<{ [Q in P]: T[P] }, { -readonly [Q in P]: T[P] }, P>
}[keyof T]

type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (k: infer I) => void
  ? I
  : never
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never

type Writable<T> = Pick<T, WritableKeys<T>>
type NonReadonly<T> = [T] extends [UnionToIntersection<T>]
  ? {
      [P in keyof Writable<T>]: T[P] extends object ? NonReadonly<NonNullable<T[P]>> : T[P]
    }
  : DistributeReadOnlyOverUnions<T>

export const roomListList = (signal?: AbortSignal) => {
  return roomListListMutator<RoomList[]>({ url: `/api/v1/room/list/`, method: 'GET', signal })
}

export const getRoomListListQueryKey = () => {
  return [`/api/v1/room/list/`] as const
}

export const getRoomListListQueryOptions = <
  TData = Awaited<ReturnType<typeof roomListList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof roomListList>>, TError, TData>>
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getRoomListListQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof roomListList>>> = ({ signal }) =>
    roomListList(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof roomListList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RoomListListQueryResult = NonNullable<Awaited<ReturnType<typeof roomListList>>>
export type RoomListListQueryError = unknown

export function useRoomListList<
  TData = Awaited<ReturnType<typeof roomListList>>,
  TError = unknown,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof roomListList>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof roomListList>>,
        TError,
        Awaited<ReturnType<typeof roomListList>>
      >,
      'initialData'
    >
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRoomListList<
  TData = Awaited<ReturnType<typeof roomListList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof roomListList>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof roomListList>>,
        TError,
        Awaited<ReturnType<typeof roomListList>>
      >,
      'initialData'
    >
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRoomListList<
  TData = Awaited<ReturnType<typeof roomListList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof roomListList>>, TError, TData>>
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useRoomListList<
  TData = Awaited<ReturnType<typeof roomListList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof roomListList>>, TError, TData>>
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRoomListListQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getRoomListListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof roomListList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof roomListList>>, TError, TData>>
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getRoomListListQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof roomListList>>> = ({ signal }) =>
    roomListList(signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof roomListList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RoomListListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof roomListList>>>
export type RoomListListSuspenseQueryError = unknown

export function useRoomListListSuspense<
  TData = Awaited<ReturnType<typeof roomListList>>,
  TError = unknown,
>(options: {
  query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof roomListList>>, TError, TData>>
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRoomListListSuspense<
  TData = Awaited<ReturnType<typeof roomListList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof roomListList>>, TError, TData>>
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRoomListListSuspense<
  TData = Awaited<ReturnType<typeof roomListList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof roomListList>>, TError, TData>>
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useRoomListListSuspense<
  TData = Awaited<ReturnType<typeof roomListList>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof roomListList>>, TError, TData>>
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRoomListListSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * Handles the creation of a user room report.

- If a new report is created, returns 201 CREATED.
- If a verified link already exists for the user and deal,
  returns 200 OK with a specific message.
 */
export const roomReportSignupCreate = (
  userRoomReportCreate: NonReadonly<UserRoomReportCreate>,
  signal?: AbortSignal,
) => {
  return roomReportSignupCreateMutator<UserRoomReportCreate>({
    url: `/api/v1/room/report-signup/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: userRoomReportCreate,
    signal,
  })
}

export const getRoomReportSignupCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof roomReportSignupCreate>>,
    TError,
    { data: NonReadonly<UserRoomReportCreate> },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof roomReportSignupCreate>>,
  TError,
  { data: NonReadonly<UserRoomReportCreate> },
  TContext
> => {
  const mutationKey = ['roomReportSignupCreate']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof roomReportSignupCreate>>,
    { data: NonReadonly<UserRoomReportCreate> }
  > = (props) => {
    const { data } = props ?? {}

    return roomReportSignupCreate(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type RoomReportSignupCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof roomReportSignupCreate>>
>
export type RoomReportSignupCreateMutationBody = NonReadonly<UserRoomReportCreate>
export type RoomReportSignupCreateMutationError = unknown

export const useRoomReportSignupCreate = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof roomReportSignupCreate>>,
    TError,
    { data: NonReadonly<UserRoomReportCreate> },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof roomReportSignupCreate>>,
  TError,
  { data: NonReadonly<UserRoomReportCreate> },
  TContext
> => {
  const mutationOptions = getRoomReportSignupCreateMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Returns a list of poker sites that allow old account reports.
 */
export const roomReportableSitesList = (signal?: AbortSignal) => {
  return roomReportableSitesListMutator<ReportablePokerSite[]>({
    url: `/api/v1/room/reportable-sites/`,
    method: 'GET',
    signal,
  })
}

export const getRoomReportableSitesListQueryKey = () => {
  return [`/api/v1/room/reportable-sites/`] as const
}

export const getRoomReportableSitesListQueryOptions = <
  TData = Awaited<ReturnType<typeof roomReportableSitesList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof roomReportableSitesList>>, TError, TData>
  >
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getRoomReportableSitesListQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof roomReportableSitesList>>> = ({
    signal,
  }) => roomReportableSitesList(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof roomReportableSitesList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RoomReportableSitesListQueryResult = NonNullable<
  Awaited<ReturnType<typeof roomReportableSitesList>>
>
export type RoomReportableSitesListQueryError = unknown

export function useRoomReportableSitesList<
  TData = Awaited<ReturnType<typeof roomReportableSitesList>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof roomReportableSitesList>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof roomReportableSitesList>>,
        TError,
        Awaited<ReturnType<typeof roomReportableSitesList>>
      >,
      'initialData'
    >
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRoomReportableSitesList<
  TData = Awaited<ReturnType<typeof roomReportableSitesList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof roomReportableSitesList>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof roomReportableSitesList>>,
        TError,
        Awaited<ReturnType<typeof roomReportableSitesList>>
      >,
      'initialData'
    >
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRoomReportableSitesList<
  TData = Awaited<ReturnType<typeof roomReportableSitesList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof roomReportableSitesList>>, TError, TData>
  >
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useRoomReportableSitesList<
  TData = Awaited<ReturnType<typeof roomReportableSitesList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof roomReportableSitesList>>, TError, TData>
  >
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRoomReportableSitesListQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getRoomReportableSitesListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof roomReportableSitesList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof roomReportableSitesList>>, TError, TData>
  >
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getRoomReportableSitesListQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof roomReportableSitesList>>> = ({
    signal,
  }) => roomReportableSitesList(signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof roomReportableSitesList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RoomReportableSitesListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof roomReportableSitesList>>
>
export type RoomReportableSitesListSuspenseQueryError = unknown

export function useRoomReportableSitesListSuspense<
  TData = Awaited<ReturnType<typeof roomReportableSitesList>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof roomReportableSitesList>>, TError, TData>
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRoomReportableSitesListSuspense<
  TData = Awaited<ReturnType<typeof roomReportableSitesList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof roomReportableSitesList>>, TError, TData>
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRoomReportableSitesListSuspense<
  TData = Awaited<ReturnType<typeof roomReportableSitesList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof roomReportableSitesList>>, TError, TData>
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useRoomReportableSitesListSuspense<
  TData = Awaited<ReturnType<typeof roomReportableSitesList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof roomReportableSitesList>>, TError, TData>
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRoomReportableSitesListSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const roomTagCreate = (roomTag: RoomTag, signal?: AbortSignal) => {
  return roomTagCreateMutator<RoomTag>({
    url: `/api/v1/room/tag/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: roomTag,
    signal,
  })
}

export const getRoomTagCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof roomTagCreate>>,
    TError,
    { data: RoomTag },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof roomTagCreate>>,
  TError,
  { data: RoomTag },
  TContext
> => {
  const mutationKey = ['roomTagCreate']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof roomTagCreate>>,
    { data: RoomTag }
  > = (props) => {
    const { data } = props ?? {}

    return roomTagCreate(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type RoomTagCreateMutationResult = NonNullable<Awaited<ReturnType<typeof roomTagCreate>>>
export type RoomTagCreateMutationBody = RoomTag
export type RoomTagCreateMutationError = unknown

export const useRoomTagCreate = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof roomTagCreate>>,
    TError,
    { data: RoomTag },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof roomTagCreate>>,
  TError,
  { data: RoomTag },
  TContext
> => {
  const mutationOptions = getRoomTagCreateMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Returns a list of all unverified/unassociated user reports of NEW account signups for the logged-in user.
OLD account reports are excluded as they don't go through the same verification process.
 */
export const roomUnverifiedReportsList = (signal?: AbortSignal) => {
  return roomUnverifiedReportsListMutator<UserUnverifiedReport[]>({
    url: `/api/v1/room/unverified-reports/`,
    method: 'GET',
    signal,
  })
}

export const getRoomUnverifiedReportsListQueryKey = () => {
  return [`/api/v1/room/unverified-reports/`] as const
}

export const getRoomUnverifiedReportsListQueryOptions = <
  TData = Awaited<ReturnType<typeof roomUnverifiedReportsList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof roomUnverifiedReportsList>>, TError, TData>
  >
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getRoomUnverifiedReportsListQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof roomUnverifiedReportsList>>> = ({
    signal,
  }) => roomUnverifiedReportsList(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof roomUnverifiedReportsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RoomUnverifiedReportsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof roomUnverifiedReportsList>>
>
export type RoomUnverifiedReportsListQueryError = unknown

export function useRoomUnverifiedReportsList<
  TData = Awaited<ReturnType<typeof roomUnverifiedReportsList>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof roomUnverifiedReportsList>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof roomUnverifiedReportsList>>,
        TError,
        Awaited<ReturnType<typeof roomUnverifiedReportsList>>
      >,
      'initialData'
    >
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRoomUnverifiedReportsList<
  TData = Awaited<ReturnType<typeof roomUnverifiedReportsList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof roomUnverifiedReportsList>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof roomUnverifiedReportsList>>,
        TError,
        Awaited<ReturnType<typeof roomUnverifiedReportsList>>
      >,
      'initialData'
    >
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRoomUnverifiedReportsList<
  TData = Awaited<ReturnType<typeof roomUnverifiedReportsList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof roomUnverifiedReportsList>>, TError, TData>
  >
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useRoomUnverifiedReportsList<
  TData = Awaited<ReturnType<typeof roomUnverifiedReportsList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof roomUnverifiedReportsList>>, TError, TData>
  >
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRoomUnverifiedReportsListQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getRoomUnverifiedReportsListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof roomUnverifiedReportsList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof roomUnverifiedReportsList>>, TError, TData>
  >
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getRoomUnverifiedReportsListQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof roomUnverifiedReportsList>>> = ({
    signal,
  }) => roomUnverifiedReportsList(signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof roomUnverifiedReportsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RoomUnverifiedReportsListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof roomUnverifiedReportsList>>
>
export type RoomUnverifiedReportsListSuspenseQueryError = unknown

export function useRoomUnverifiedReportsListSuspense<
  TData = Awaited<ReturnType<typeof roomUnverifiedReportsList>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof roomUnverifiedReportsList>>, TError, TData>
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRoomUnverifiedReportsListSuspense<
  TData = Awaited<ReturnType<typeof roomUnverifiedReportsList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof roomUnverifiedReportsList>>, TError, TData>
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRoomUnverifiedReportsListSuspense<
  TData = Awaited<ReturnType<typeof roomUnverifiedReportsList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof roomUnverifiedReportsList>>, TError, TData>
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useRoomUnverifiedReportsListSuspense<
  TData = Awaited<ReturnType<typeof roomUnverifiedReportsList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof roomUnverifiedReportsList>>, TError, TData>
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRoomUnverifiedReportsListSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}
